<template>
  <div id="app" class="container-fluid">
    <router-view/>
  </div>
</template>

<script>
import Header from './components/Header';

export default {
  name: 'App',
  components : {
  	appHeader : Header
  }
}
</script>

<style>
@import 'assets/css/bootstrap.min.css';
@import 'https://unpkg.com/nprogress@0.2.0/nprogress.css';
@import 'https://use.fontawesome.com/releases/v5.5.0/css/all.css';

/*Override the styles*/
#nprogress .bar {
  height: 5px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue